import type { BaseReactProps, ReactNodeDef } from '@shared/node-v1.0.0'
import { getPortDef } from '@shared/port-v1.0.0'
import Comp from '../component'

export type Props = BaseReactProps & {}

export default {
	hashTag: '#pre-release',
	module: { static: Comp },
	inNode: {
		inputs: [
			getPortDef({ name: 'w', displayName: 'Width', group: 'Dimensions', type: 'string' }),
			getPortDef({
				name: 'transitionDuration',
				displayName: 'Transition duration',
				group: 'Styles',
				type: 'number',
				default: 200,
			}),
			getPortDef({
				name: 'transitionTimingFunction',
				displayName: 'Transition timing function',
				group: 'Styles',
				type: 'string',
				default: 'ease',
			}),
			getPortDef({ name: 'toggle', displayName: 'Toggle', group: 'Signals', type: 'signal' }),
			getPortDef({ name: 'expand', displayName: 'Expand', group: 'Signals', type: 'signal' }),
			getPortDef({ name: 'collapse', displayName: 'Collapse', group: 'Signals', type: 'signal' }),
		],
		outputs: [
			getPortDef({ name: 'state', displayName: 'State', group: 'States', type: 'boolean' }),
			getPortDef({ name: 'expanded', displayName: 'Expanded', group: 'Signals', type: 'signal' }),
			getPortDef({ name: 'collapsed', displayName: 'Collapsed', group: 'Signals', type: 'signal' }),
		],
	},
} satisfies ReactNodeDef
